import React from 'react';

import { ContentCard, ContentCardIconType } from 'ui/component';

import classNames from './EABDScriptingContentCard.module.scss';

export interface ScriptingContentCardProps {
  readonly isInFocus: boolean;
  readonly style?: React.CSSProperties;
}

export const ScriptingContentCard = React.memo<ScriptingContentCardProps>((props) => {
  const { isInFocus, style } = props;

  return (
    <ContentCard title={'Scripting'} iconType={ContentCardIconType.CODE} isInFocus={isInFocus} style={style}>
      <p className={classNames.body}>{'Simple rules to automate certain tasks.'}</p>
    </ContentCard>
  );
});
